import React, { useEffect, useRef } from 'react';
import ReactModal from 'react-modal';
import { BuildPath } from '../../helpers/Paths';

type Props = {
    hideCloseButton?: boolean
    isOpen:boolean, 
    children:any,
    escClose?:boolean
    onRequestClose: (openModal:boolean) => void;
    className?: string;
    isFullPage?:boolean;
}

const ModalWrapper = (props: Props) => {
    const { isOpen, onRequestClose, children, escClose } = props;
    const imgRef = useRef<HTMLImageElement>(null);
    
    const autoClose = () => {
        if(escClose !== false){
             onRequestClose(false)
        }
    }

    // prevent scroll when modal is open
    useEffect(() =>  {
        if (isOpen) {            
            imgRef.current?.focus();
            document.body.style.overflowY = "hidden"
        } else {
            document.body.style.overflowY = "initial"
        }

        return () => { 
            document.body.style.overflowY = "initial";
        }
    }, [isOpen])

    return (

        <ReactModal
            style={{overlay: {zIndex: 50}}}
            closeTimeoutMS={200}                  
            isOpen={isOpen}
            contentLabel=""
            className={`thrive-modal ${props.className}`}
            overlayClassName={`thrive-modal-overlay ${props.isFullPage ? 'fullpage-modal' : ''}`}
            onRequestClose={() => {autoClose()}}
            ariaHideApp={false}>

            {!props.hideCloseButton && 
                <img
                    src={`${BuildPath()}/images/buttons/CloseModal.svg`}
                    className="closeModal"
                    onClick={() => onRequestClose(false)}
                    alt="Close"
                    ref={imgRef}
                    tabIndex={0}
                />
            }
                
            {children}    
        </ReactModal>

    );  
}

export default ModalWrapper;